import React from 'react';
import PropTypes from 'prop-types';
import {
  RecommendedCourseContent,
  RecommendedCoursesScroller,
  RecommendedCoursesContainer,
  RecommendedCoursesHeader,
  RecommendedMeta,
  RecommendedPrice,
  RecommendedImageWrap,
  EachRecommendedCourse,
} from './RecommendedCourse.styles';
import { useNavigate } from 'react-router-dom';
import FillerImage from '../../../Visuals/Images/small.png';
import { slugify } from '../slugify';

const EachRecommended = ({ courses, course: cI, ip = false }) => {
  const navigate = useNavigate();
  const handleCourseClick = (courseId, courseName) => {
    if (ip) {
      navigate(`/inspectionpal/course/${slugify(courseName)}/${courseId}`);
    } else {
      navigate(`/course/${slugify(courseName)}/${courseId}`);
    }
  };

  let filteredCourses = courses || [];
  // If a reference course is provided, filter by tags and exclude itself
  if (cI && Array.isArray(cI.tags) && cI.tags.length > 0) {
    filteredCourses = filteredCourses
      .filter(
        (c) =>
          c?._id !== cI._id &&
          Array.isArray(c.tags) &&
          c.tags.some((tag) => cI.tags.includes(tag))
      )
      .slice(0, 15);
  }

  return (
    <RecommendedCoursesContainer>
      <RecommendedCoursesHeader>
        <div>
          <h3>You may also be interested in</h3>
          <p>Additional courses related to this training program.</p>
        </div>
      </RecommendedCoursesHeader>

      <RecommendedCoursesScroller>
        {Array.isArray(filteredCourses) &&
          filteredCourses.map((course) => (
            <EachRecommendedCourse
              key={course?._id}
              onClick={() => handleCourseClick(course?._id, course?.courseName)}
            >
              <RecommendedImageWrap>
                <img
                  src={course?.image === '' ? FillerImage : course?.image}
                  alt={course?.courseName}
                />
              </RecommendedImageWrap>

              <RecommendedCourseContent>
                <h5>{course?.courseName}</h5>

                <RecommendedMeta>
                  <span>
                    {course?.expiryDate
                      ? `Valid ${course.expiryDate} years`
                      : 'Online Course'}
                  </span>
                </RecommendedMeta>

                <RecommendedPrice>
                  {course?.price ? `$${course.price}` : 'Contact for pricing'}
                </RecommendedPrice>
              </RecommendedCourseContent>
            </EachRecommendedCourse>
          ))}
      </RecommendedCoursesScroller>
    </RecommendedCoursesContainer>
  );
};
EachRecommended.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      courseName: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      price: PropTypes.number,
    })
  ),
  course: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
  ip: PropTypes.bool,
};

export default EachRecommended;
